import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  email: string;
  name: string;
  phone: string;
  phoneCountryCode: string;
  source: string;
  text: string;
  university: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall('POST', `${APIV2_URL}/action/contact`, { data });
